'use strict';

angular.module('utils').factory('OCAnalyticsUtil', function(CurrentUser, ClinicConfig, OCCDoctorUtil) {
  var self = {
    log: function(eventName, props, integrations) {
      var isDevOrStagingOrDemo = _.includes(['development', 'staging', 'demo'], ClinicConfig.ENV);

      if (isDevOrStagingOrDemo) {
        var formattedIntegrations = '[' + _.keys(_.omit(integrations || {}, function(value) {
          return !value;
        })) + ']: ';

        console.log(integrations ? formattedIntegrations : '', eventName, props || '');
      }
    },

    bootUserAnalytics: function() {
      CurrentUser.waitForUserLoad(CurrentUser.getUser).then(function(user) {
        if (!user.authenticated) {
          return;
        }

        // APPCUES
        var firstClinicId = null;
        var firstDoctorId = null;

        var isOnboardingEnabled = false;
        var clinics = CurrentUser.getClinics();
        var doctors = CurrentUser.getDoctors();

        var sortElementsByName = function(a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        };

        if (clinics && clinics.length) {
          firstClinicId = clinics.sort(sortElementsByName)[0].id;

          clinics.forEach(function(c) {
            if (c.metadata && c.metadata.enableOnboardingWizardV2 === true) {
              var permission = user.permissions.find(function(p) {
                return p.modelId === c.id && p.modelType === 'Clinic' && p.permissionType === 'O' && !p.deletedAt;
              });

              if (permission) {
                isOnboardingEnabled = true;
              }
            }
          });
        }

        if (doctors && doctors.length) {
          firstDoctorId = doctors.sort(sortElementsByName)[0].id;
        }

        const isImpersonated = CurrentUser.isImpersonated();
        const userId = `${user.id}-${ClinicConfig.ENV}${isImpersonated ? '-impersonated' : ''}`;
        const appcuesUserProps = {
          name: user.firstName + ' ' + user.lastName,
          email: user.email,
          isImpersonated,
          isInsuranceAvailable: OCCDoctorUtil.isInsuranceAvailable(doctors[0]),
          environment: ClinicConfig.ENV,
          firstClinicId: firstClinicId,
          firstDoctorId: firstDoctorId,
          createdAt: user.createdAt,
          isOnboardingEnabled: isOnboardingEnabled,
        };

        if (ClinicConfig.ENV !== 'production') {
          console.log('Setting up Appcues for User "' + userId + '".', appcuesUserProps);
        }

        self.appcues.setUserProps(userId, appcuesUserProps);
      });
    },

    setUserInfo: function(user) {
      // Rollbar
      Rollbar.configure({
        payload: {
          person: _.pick(user, ['id', 'email']),
        },
        transform: function(payload) {
          // Add the FullStory session URL to the Rollbar payload
          if (window.FS && window.FS.getCurrentSessionURL) {
            payload.fullstorySessionURL = window.FS.getCurrentSessionURL(true);
          }

          // Add the Heap User ID and Session ID to the Rollbar payload
          if (window.heap && window.heap.userId) {
            payload.heapUserId = window.heap.userId;
            payload.heapSessionId = window.heap.getSessionId();
          }
          return payload;
        },
      });
    },

    appcues: {
      setUserProps: function(userId, props) {
        if (window.Appcues) {
          window.Appcues.identify(userId, props);
        }
      },
    },
  };

  return self;
});
